<div class="sidebar-container" style="width: 100%; height: 100%">
  <!-- Sidebar Drawer (slides in from right when open) -->
  <div
    class="sidebar-drawer"
    #sideNav
    [class.sidebar-open]="hasActiveComponentItem()"
  >
    <side-bar-header
      [sideNav]="sideNav"
      [pages]="sidebarService.pages()"
    ></side-bar-header>
    <div class="router-container flex flex-grow flex-col">
      <!-- Route-based content -->
      <router-outlet></router-outlet>

      <!-- Component-based content -->
      <div class="component-container">
        @for (item of getActiveComponentItems(); track item.id) {
          <div class="component-item">
            <ng-container *ngComponentOutlet="item.component; inputs: item.componentInputs || {}"></ng-container>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Sidebar Navigation Bar (always visible on right) -->
  @if ({isSmall: isSmallScreen()}; as screen) {
  <div
    class="sidebar-nav"
    [ngClass]="{
      'sidebar-nav--bottom': screen.isSmall,
      'sidebar-nav--right': !screen.isSmall
    }"
    [style.display]="display()"
  >
    <ul>
      <!-- Render sidebar items from service pages -->
      @for (page of sidebarService.pages(); track $index;) {
      <li
        class="nav-item"
        [ngClass]="{
          'sidebar-page_active': page.active,
          'last-item': sidebarService.pages().length > 1 && $last
        }"
        appTooltip
        [appTooltip]="page.title"
        [tooltipPosition]="screen.isSmall ? 'top' : 'left'"
      >
        <button
          [disabled]="page.disabled"
          [style.width]="'100%'"
          [style.height]="'100%'"
          (click)="handlePageClick(page)"
        >
          <span>
            <!-- Use custom sidebar icon template if available, otherwise use default icon -->
            @if ('id' in page && getSidebarIconTemplate(page.id)) {
              <ng-container [ngTemplateOutlet]="getSidebarIconTemplate(page.id)"></ng-container>
            } @else {
              <i 
                [class]="page.className"
                [class.animate-pulse]="page.id === 'reporting' && isActivePropertySelected()"
                [class.text-yellow-400]="page.id === 'reporting' && isActivePropertySelected()"
              ></i>
            }
          </span>
        </button>
      </li>
      }
    </ul>
  </div>
  }
</div>

<!-- Projected sidebar items for configuration -->
<ng-content></ng-content>
